import { FreeQrCodeGeneratorVariation1Document } from '@dtx-company/prismic-codegen'

export const LocgV2DataMock: FreeQrCodeGeneratorVariation1Document['data'] = {
  page_title__mobile: [{ type: 'heading1', text: 'Flowcode: Free QR code generator', spans: [] }],
  page_title__desktop: [{ type: 'heading1', text: 'Flowcode: Free QR code generator', spans: [] }],
  heading_chip: [
    {
      key: 'neverExpires',
      icon: 'auto_awesome',
      text: 'Never expires',
      link: {
        link_type: 'Web',
        url: 'https://support.flowcode.com/will-my-codes/pages-expire-go-to-flowcode',
        target: '_blank'
      }
    },
    {
      key: 'scans',
      icon: 'privacy_tip_outlined',
      text: 'Unlimited scans',
      link: {
        link_type: 'Web',
        url: 'https://support.flowcode.com/is-flowcode-qr-free-is-there-a-scan-limit-go-to-flowcode',
        target: '_blank'
      }
    }
  ],
  best_practices: [
    {
      key: 'scan-destination',
      title: 'Can’t decide where to direct audiences to?',
      description: 'Click to read what others are doing with their Flowcodes.',
      link: 'https://www.flowcode.com/use-cases?utm_source=LOCG&utm_medium=Website&utm_campaign=&utm_content=best_practices&utm_term=scan_destination',
      mobile_cta: 'See use cases',
      ispro: false
    },
    {
      key: 'color-selector',
      title: 'Want even more colors?',
      description: 'Upgrade to a Pro plan to access premium customization.',
      link: 'https://www.flowcode.com/plans?utm_source=LOCG&utm_medium=Website&utm_campaign=&utm_content=best_practices&utm_term=color_selector',
      mobile_cta: 'See our plans',
      ispro: true
    },
    {
      key: 'shape-selector',
      title: 'Circle or square?',
      description: 'Flowcode’s unique circle QR code will set your QR code apart from others.',
      link: null,
      mobile_cta: null,
      ispro: false
    },
    {
      key: 'frame-and-text',
      title: 'Directions always help',
      description: 'Add text like "scan here" to get more engagement on your code.',
      link: null,
      mobile_cta: null,
      ispro: false
    },
    {
      key: 'logo',
      title: 'Don’t have a logo ready?',
      description: 'Update anytime after sign up.',
      link: 'https://www.flowcode.com/plans?utm_source=LOCG&utm_medium=Website&utm_campaign=&utm_content=best_practices&utm_term=logo',
      mobile_cta: 'Choose plan',
      ispro: true
    }
  ],
  code_preview: [
    {
      caption_line_1: 'This is a preview of your code.',
      caption_line_2: 'Once created, your code will scan to:'
    }
  ],
  auth_trial: [
    {
      '0': 'Free 30-day trial of premium features',
      '1': 'Unlimited scans',
      '2': 'Free forever for core features',
      '3': 'No credit card required'
    }
  ]
}
